// extracted by mini-css-extract-plugin
export default {"leftSmallImg":"notificationCard_leftSmallImg__czgOs","leftSmallItem":"notificationCard_leftSmallItem__+W-RN"};